<template>
    <AppHeader />
  
    <div class="container mx-auto p-4">
      <div class="max-w-5xl mx-auto bg-white dark:bg-slate-800 text-slate-900 dark:text-slate-100 rounded-lg shadow-md overflow-hidden">
        <div class="p-4 border-b dark:border-slate-700 flex items-center justify-between">
          <h2 class="text-lg font-semibold text-gray-900 dark:text-gray-100">
            Usuários & Permissões
          </h2>
          <div class="flex gap-2">
            <label class="text-xs text-gray-500 dark:text-gray-400 self-center">
              Número máximo de dias permitido para registro de atividade
            </label>
            <select v-model="num_max_days">
              <option v-for="i in 28" :key="i" :value="i + 2">
                {{ i + 2 }}
              </option>
            </select>
            <button
              @click="saveMaxDays"
              class="px-2 py-1 text-xs rounded-md bg-slate-600 text-white hover:bg-slate-700"
            >
              Salvar
            </button>
            <span v-if="saveSucess" class="text-xs text-green-500 self-center">Salvo!</span>
            <input
              v-model.trim="filters.q"
              type="text"
              placeholder="Buscar por nome ou e-mail…"
              class="px-3 py-2 border rounded-md dark:bg-slate-800 dark:border-slate-700 dark:text-gray-100"
            />
            <select
              v-model="filters.unit"
              class="px-3 py-2 border rounded-md dark:bg-slate-800 dark:border-slate-700 dark:text-gray-100"
            >
              <option value="">Todas as unidades</option>
              <option value="GEAAL">GEAAL</option>
              <option value="GEOF">GEOF</option>
              <option value="GPI">GPI</option>
            </select>
            <button
              @click="resetFilters"
              class="px-3 py-2 rounded-md bg-slate-600 text-white hover:bg-slate-700"
            >
              Resetar
            </button>
          </div>
        </div>
  
        <div class="p-4 overflow-x-auto">
          <div v-if="error" class="mb-3 text-sm text-red-500">{{ error }}</div>
  
          <table class="min-w-full text-sm">
            <thead class="text-left bg-gray-50 text-slate-900 dark:bg-slate-700/60 dark:text-slate-100">
              <tr>
                <th class="px-3 py-2">Nome</th>
                <th class="px-3 py-2">E-mail</th>
                <th class="px-3 py-2">Unidade</th>
                <th class="px-3 py-2 text-center">Manager</th>
                <th class="px-3 py-2 text-center">Admin</th>
                <th class="px-3 py-2 text-right">Ações</th> <!-- ← título atualizado -->
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="u in users"
                :key="u.id"
                class="border-b border-gray-200 dark:border-slate-700 hover:bg-gray-50 dark:hover:bg-slate-700/40 last:border-0"
              >
                <td class="px-3 py-2">{{ u.name }}</td>
                <td class="px-3 py-2">{{ u.email }}</td>
                <td class="px-3 py-2">{{ u.unit }}</td>
                <td class="px-3 py-2 text-center">
                  <input type="checkbox" :checked="u.manager" @change="toggle(u, 'manager', $event.target.checked)" />
                </td>
                <td class="px-3 py-2 text-center">
                  <input type="checkbox" :checked="u.admin" @change="toggle(u, 'admin', $event.target.checked)" />
                </td>
                <td class="px-3 py-2 text-right text-xs text-gray-500 dark:text-gray-400">
                  <span v-if="saving[u.id]">salvando…</span>
                  <button
                    class="ml-2 px-2 py-1 text-xs bg-red-600 text-white rounded hover:bg-red-700 disabled:opacity-50"
                    :disabled="!!saving[u.id]"
                    @click="promptDeleteUser(u)"
                  >
                    Excluir
                  </button>
                </td>
              </tr>
              <tr v-if="!users.length && !loading">
                <td colspan="6" class="px-3 py-6 text-center text-gray-500 dark:text-gray-400">Nenhum usuário encontrado.</td>
              </tr>
            </tbody>
          </table>
  
          <div v-if="loading" class="mt-3 text-sm text-gray-500 dark:text-gray-400">Carregando…</div>
        </div>
      </div>
    </div>

    <!-- Modal de confirmação de exclusão -->
    <div v-if="showDeleteModal" class="fixed inset-0 z-50 flex items-center justify-center">
      <div class="absolute inset-0 bg-black/50" @click="cancelDelete"></div>
      <div class="relative bg-white dark:bg-slate-800 rounded-lg shadow-lg w-full max-w-md mx-4">
        <div class="p-4 border-b dark:border-slate-700">
          <h3 class="text-lg font-semibold text-gray-900 dark:text-gray-100">Confirmar exclusão</h3>
        </div>
        <div class="p-4">
          <p class="text-sm text-gray-700 dark:text-gray-300">
            Deseja realmente excluir o usuário
            <strong>{{ userToDelete?.name }}</strong>
            (<span class="font-mono text-xs">{{ userToDelete?.email }}</span>)?
          </p>
        </div>
        <div class="p-4 flex justify-end gap-2 border-t dark:border-slate-700">
          <button class="px-3 py-2 rounded-md bg-gray-200 text-slate-900 dark:bg-slate-700 dark:text-slate-100" @click="cancelDelete" :disabled="deleting">
            Cancelar
          </button>
          <button
            class="px-3 py-2 rounded-md bg-red-600 text-white"
            @click="confirmDelete"
            :disabled="deleting"
          >
            <span v-if="deleting">Excluindo…</span>
            <span v-else>Excluir</span>
          </button>
        </div>
      </div>
    </div>
  </template>
  
  <script>
  import axios from 'axios'
  import AppHeader from './Header.vue'
  
  export default {
    name: 'AdminUsers',
    components: { AppHeader },

  
    data() {
      const isLocal = ['localhost', '127.0.0.1'].includes(window.location.hostname)
      return {
        apiBase: isLocal ? 'http://localhost:5000' : '/api',
        users: [],
        loading: false,
        error: '',
        filters: { q: '', unit: '' },
        filterTimer: null,
        saving: {}, // { [userId]: true|false }
        // modal state
        showDeleteModal: false,
        userToDelete: null,
        deleting: false,
        num_max_days: 3,
        saveSucess: false
      }
    },
    watch: {
      filters: {
        deep: true,
        handler() {
          clearTimeout(this.filterTimer)
          this.filterTimer = setTimeout(() => this.load(), 300)
        },
      },
    },
    async created() {
      await this.loadMaxDays()
      this.load()
    },
    beforeUnmount() {
      clearTimeout(this.filterTimer)
    },
    
    methods: {
      async loadMaxDays() {
        const { data } = await axios.get(`${this.apiBase}/activities/num-days`, {
          headers: { Authorization: `Bearer ${localStorage.getItem('token')}` }
        })
        this.num_max_days = data.num_max_days
      },
      async saveMaxDays() {
        await axios.post(`${this.apiBase}/admin/users/num-days`, 
          { num_max_days: this.num_max_days}, 
          { headers: { Authorization: `Bearer ${localStorage.getItem('token')}`}}
        )
        this.saveSucess = true
        setTimeout(() => (this.saveSuccess = false), 2500)
      },
      async load() {
        this.error = ''
        this.loading = true
        try {
          const params = {}
          if (this.filters.q)    params.q    = this.filters.q
          if (this.filters.unit) params.unit = this.filters.unit
  
          const { data } = await axios.get(`${this.apiBase}/admin/users`, {
            params,
            headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
          })
          this.users = Array.isArray(data) ? data : []
        } catch (e) {
          console.error(e)
          this.users = []
          this.error = e?.response?.data?.error || 'Falha ao carregar usuários.'
        } finally {
          this.loading = false
        }
      },
      resetFilters() {
        this.filters = { q: '', unit: '' }
        this.load()
      },
      async toggle(user, key, value) {
        // key in ['admin','manager']
        this.$set?.(this.saving, user.id, true) || (this.saving[user.id] = true)
        try {
          const body = { [key]: !!value }
          const { data } = await axios.patch(
            `${this.apiBase}/admin/users/${user.id}`,
            body,
            { headers: { Authorization: `Bearer ${localStorage.getItem('token')}` } }
          )
          // reflect returned state
          user.admin   = !!data.admin
          user.manager = !!data.manager
  
          // If current user changed their own admin bit, refresh localStorage user
          const me = JSON.parse(localStorage.getItem('user') || '{}')
          if (me?.id === user.id) {
            me.admin = user.admin
            me.manager = user.manager
            localStorage.setItem('user', JSON.stringify(me))
          }
        } catch (e) {
          console.error(e)
          // revert checkbox on error
          user[key] = !value
          this.error = e?.response?.data?.error || 'Falha ao atualizar permissões.'
        } finally {
          this.$set?.(this.saving, user.id, false) || (this.saving[user.id] = false)
        }
      },
      // abre modal
      promptDeleteUser(user) {
        this.userToDelete = user
        this.showDeleteModal = true
      },
      cancelDelete() {
        this.userToDelete = null
        this.showDeleteModal = false
        this.deleting = false
      },
      async confirmDelete() {
        if (!this.userToDelete) return
        const user = this.userToDelete
        this.deleting = true
        this.$set?.(this.saving, user.id, true) || (this.saving[user.id] = true)
        try {
          await axios.delete(
            `${this.apiBase}/admin/users/${user.id}`,
            { headers: { Authorization: `Bearer ${localStorage.getItem('token')}` } }
          )
          this.users = this.users.filter(u => u.id !== user.id)
          const me = JSON.parse(localStorage.getItem('user') || '{}')
          if (me?.id === user.id) {
            localStorage.removeItem('token')
            localStorage.removeItem('user')
            delete axios.defaults.headers.common.Authorization
            this.$router.replace('/login')
          }
          this.cancelDelete()
        } catch (e) {
          console.error('Failed to delete user', e)
          this.error = e?.response?.data?.error || 'Falha ao excluir usuário.'
        } finally {
          this.deleting = false
          this.$set?.(this.saving, user.id, false) || (this.saving[user.id] = false)
        }
      },
    },
  }
  </script>
